"use strict";
import { Z_INDEX } from "theme/zIndex";
if (process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID === void 0) {
  throw new Error("REACT_APP_WALLET_CONNECT_PROJECT_ID must be a defined environment variable");
}
const WALLET_CONNECT_PROJECT_ID = process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID;
export const walletTypeToAmplitudeWalletType = (connectionType) => {
  switch (connectionType) {
    case "injected":
      return "Browser Extension";
    case "walletConnect":
      return "Wallet Connect";
    case "coinbaseWallet":
      return "Coinbase Wallet";
    case "binanceWallet":
      return "Binance Wallet";
    case "MetamaskWallet":
      return "Metamask Wallet";
    default:
      return connectionType ?? "Network";
  }
};
export const WC_PARAMS = {
  projectId: WALLET_CONNECT_PROJECT_ID,
  metadata: {
    name: "Topaz",
    description: "Topaz Dex",
    url: window.location.origin,
    icons: ["/images/favicon.ico"]
  },
  showQrModal: true,
  qrModalOptions: {
    themeVariables: {
      "--wcm-font-family": '"Nunito Sans", sans-serif',
      "--wcm-z-index": Z_INDEX.modal.toString()
    }
  }
};
